export default {
  common: {
    selectAll: 'Select All',
    cancel: 'Cancel',
    comfirm: 'Confirm',
    action: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    reminder: 'Send Reminder',
    reminder2: 'Reminder',
    detail: 'Details',
    print: 'Print',
    warning: 'Waring',
    warning2: 'Reminder',
    clear: 'Clear',
    set: 'Set',
    setting: 'Setting',
    tips: 'Tips',
    hanldeIsDangerous: 'Dangerous Operation in Progress!',
    uploadFailed: 'Upload failed! please try again!',
    printOrder: 'Print Bill',
    pay: 'Pay',
    refund: 'Refund',
    yes: 'Yes',
    no: 'No',
    handleSuccess: 'Operation Successful',
    closeWarning: 'Are you sure to close the DoLA POS system (Not closing today’s sales)?',
    netError: 'Your Internet is slow, please wait (you may need to check the previous order)',
    netErrorTryAgain: 'Your Internet is slow, please try again',
    netErrorCheck: 'Your Internet is slow, please check',
    loginByOtherDriver: 'You’ve been logged from other devices',

    tax: 'Sales Tax',
    tax2: 'Tax',
    tip: 'Tips',
    packageFee: 'Packing Fee',
    serviceFee: 'Service Charge',
    tipServiceFee: 'Tips/Service Charge',
    price: 'Subtotal',
    discount: 'Discount',
    discounttakeaway: 'Take-away Discount',
    discounttakeaway2: 'Togo DIS.',
    total: 'Total',
    totalBill: 'Bill Total',
  },
  error: {
    illegalPage: 'Illegal Page',
  },
  index: {
    inBusiness: 'Open',
    outBusiness: 'Closed',
    deviceStatus: 'Device Status',
    deviceError: 'Device Error！',
    viewDetail: 'View Detail',
    errorReason: 'Error Reason',
    remindMe10: 'Remind Me in 10 Minutes',
    remindMe30: 'Remind Me in 30 Minutes',
    remindMe60: 'Remind Me in 1 hour',
    remindMe180: 'Remind Me in 3 hours',
    remindMe24: 'Remind Me Tomorrow',
    monitor: 'Touch Screen',
    reader: 'Terminal',
    printer: 'Printer',
    linkOk: 'Connected',
    linkError: 'Error',
    linkFail: 'Disconnected',
    thisOne: 'Your Screen',
    paperOut: 'Paper Run Out',
    startBusiness: 'Start Today',
    currentScene: 'Scene',
    noScene: 'No Scene',
    toggloFullScreen_false: 'Switch to Full Screen',
    toggloFullScreen_true: 'Exit Full Screen',
    dateControl: 'Days of Week Control',
    editPassword: 'Change Password',
    myFeedback: 'My Feedback',
    lock: 'Lock Screen',
    logout: 'Logout',
    logoutConfirm: 'Confirm Logout? ',
    errorMessage: 'Store Information Error, Please Sign in Again',
    orderDeteled: 'The order has been deleted',
    // orderNewNeedHandle: '您有新的落單審核需要處理',
    // clickThenJumpToOrderNew: '點擊跳囀到落單審核頁面',
    cash1: 'Cash',
    cashInAndOut: 'Cash In & Out',
    inputCash: 'Please enter cash',
    cashIn: 'Cash In',
    cashOut: 'Cash Out',
    inputOtherReason: 'Please enter others reason',

    notFindPrivilege: 'Permission query failed, please try again',

    feedback: 'Report Error',
    home: 'Home',
    table: 'Table',
    menu: 'Menu',
    lineup: 'Queue',
    order: 'Orders',
    items: 'Inventory',
    shop: 'Store Status',
    qrcode: 'QR Code',
    member: 'Members',
    orderNew: 'Verify',
    book: 'Reservations',
    cash: 'Cash Management',
  },
  menu: {
    takeaway: 'Take-away',
    tangshi: 'Dine-in',
    // tableNo: 'Table No.',
    unit: 'Order',
    remarks: 'Remarks',
    sendKitchen: 'Send Kitchen',
    printOrder: 'Print Bill',
    calc: 'Pay',
    name: 'Name',
    phone: 'Contact Number',
    inputItemName: 'Please enter a name',
    cartIsEmpty: 'The basket is empty',
    all: 'All',
    hot: '	Popular',
    multi: 'Multiple Choices',
    required: 'Required Choices',
    specLimit1: 'Required ',
    specLimit2: 'Select up to ',
    specLimit3: 'Required, Select ',
    min: 'min',
    max: 'max',
    selectSpec: 'Selected Items',
    refresh: 'Update Basket',
    refreshAndSend: 'Update Basket & Sent Kitchen',
    add: 'Add to Basket',
    cart: 'Basket',
    addItemWarning: 'Fail to add to basket, please check your selections',
    customFood: 'Custom Order',
    customFoodName: 'Custom Name',
    customFoodNamePlanceholder: 'Please enter the name',
    customFoodPrice: 'Custom Price',
    customFoodPricePlanceholder: 'Please enter the price',
    customFoodPrinter: 'Please select print',
    customFoodPrinterPlanceholder: 'Please select print',
    off9: '10% OFF',
    off8: '20% OFF',
    off5: '50% OFF',
    off11: 'Service Charge 10%',
    off12: 'Service Charge 20%',
    off13: 'Service Charge 30%',
    timePrice: 'Seasonal Price',
    timePriceFood: 'Seasonal Price',
    pickupTime: 'Pickup Time',
    hour: 'Hour',
    minute: 'Minute',
    now: "Now",
    sceneMustSelect: "Please select the menu",
    sceneChangeWarning: "Please click the menu in the title of the shopping basket to change the menu",
    reminderSentSuccess: "Reminder Sent",
  },
  coupon: {
    coupons: 'Coupons',
    discountCode: 'Discount',
    inputDiscountCode: 'Enter Discount Code',
    noCoupon: 'No Such Discount',
    cannotBind: 'Can not Proceed',
    used: 'Redeemed',
    expired: 'Expired',
    value: 'Discount',
    applicableShop: 'Branches',
    applicableFood: 'Choices',
    validityTime: 'Valid Period',
    restrictions: 'Rules',
    termsOfUse: 'Terms',
  },
  pay: {
    payTypeIsEmpty: 'No payment method found, please check the Payment Settings in DoLA Dashboard',
    payResult: 'Payment',
    payWay: 'Payment Methods',
    paySuccess: 'Payment Successful',
    finPay: 'Payment Complete',
    payCardComfirm: 'Payment Confirmation',
    payCardComfirmTip: 'Please confirm that payment has successfully received',
    payComfirm: 'Confirm',
    payNot: 'Cancel',
    eftPayFailed: 'EFT Terminal Payment is Failed!',
    eftRefundFailed: 'EFT Terminal Refund is Failed!',
    eftPayTimeOut: 'EFT Terminal Payment is Time Out!',
    eftPayLastPending: 'The result of the previous payment in EFT Terminal is unknown, please check with your guest to see if the payment has been made to continue',
    eftPayLastSuccessed: 'Notice: The previous payment of EFT Terminal succeeded ',
    eftPayLastFailed: 'Notice: The previous payment of EFT Terminal failed',
    eftPayIsNotSupport: 'Card terminal is not supported on the web version of DoLA POS',
  },
  calc: {
    calcWay: 'Payment Methods',
    tip: 'Please confirm your discount code before continue! ',
    calcWay1: 'Pay All',
    calcWay2: 'Pay by Share',
    calcWay3: 'Pay by Order',
    totalPrice: 'Total',
    total: 'Total',
    unassigned: 'Remain',
    unpaidPrice: 'Unpaid',
    byPerson: 'Even Split',
    byCustom: 'Customize Split',
    inputEatCount: 'Please enter No. of people',
    inputCustomPrice: 'Please enter how much you want to pay',
    inputCustomPrice_cashdialog: 'Enter Amount Received',
    payLeft: 'Pay the Rest',
    payStatus1_: 'Unpaid',
    payStatus2_: 'Paid',
    payStatus1: 'Unpaid',
    payStatus2: 'Paid',
    unit: 'Person',
    cancelCalcAndRefund: 'Cancel Payment & Refund All',
    cancelCalc: 'Cancel Payment',
    haveChosenPayDirectly: 'You have selected - Pay All',
    haveChosenPayByMoney: 'You have selected - Pay Your Share',
    haveChosenPayByFood: 'You have selected - Pay Your Order',
    haveChosenPayByPerson: 'You have selected - Even Split',
    haveChosenPayByCustom: 'You have selected - Customize Split',
    paidPartByFood: 'Some orders have been paid',
    paidPartByPerson: 'Someone paid - Even Split',
    paidPartByCustom: 'Someone paid - Customize Split',
    couponError: 'Discount Code Error',
    totalError: 'Over the unpaid. Please re-enter.',
    received: 'Cash Received',
    change: 'Cash Change',
    payCashNotEnough: 'The amount you entered is less than the total, please re-enter',
    personNumberError: 'Please enter a valid number',
    personNumberExceedsLimit: 'Please enter a nunber that is less than or equal to 20',
    moneyNumberError: 'Please enter a valid number',
    couponHasInputedOnlyCanCalcAll: 'Please delete the coupon to continue splitting',
    memberHasBoundOnlyCanCalcAll: 'Please disconnect membership to continue splitting',
    shouldPay: 'You Pay',
    changePayTypeAfterPaid: 'Change Payment Method',
  },
  food: {
    food: 'Pay by Order',
    childOrderNum: 'Splitted',
    paid: 'Paid',
    deleteTip: 'The order in this bill will be moved back to the original bill. Please confirm to continue!',
    cancelCalc: 'Cancel Payment',
    order: ' Bill',
    finPay: 'Payment Complete',
    noItem: 'No Item',
    choice: 'Choice',
    add: 'Add',
  },
  feedback: {
    feedback: 'Support',
    title: 'Subject',
    content: 'Content',

    feedbackList: 'My Feedbacks',
    index: 'No.',
    shortdate: 'Time',
    status: 'Status',
    dealPerson: 'From',

    status1: 'Waiting',
    status2: 'Answered',
    status3: 'Completed',

    feedbackTime: 'Time',
    inputReply: 'Please enter your questions',
    reply: 'Submit',
    platform: 'Platform',
  },
  key: {
    psd: 'Please enter your key',
    inputPsd: 'Please enter your key',
    inputWaiterPsd: 'Please enter your key',
    selectReason: 'Please Select Reasons',
    reason1: 'Customer Return',
    reason2: 'Run Out Stock',
    reason3: 'Server Mistakes',
    reason4: 'Others',
    editDateWarning1: 'Reminder: ',
    editDateWarning2: 'After your confirmation, the day of week won\'t change anymore until closing',
    currentDate: 'Current Date',
    editDate: 'Change Day of Week to',
    day1: 'Monday',
    day2: 'Tuesday',
    day3: 'Wednesday',
    day4: 'Thursday',
    day5: 'Friday',
    day6: 'Saturday',
    day7: 'Sunday',
  },
  home: {
    takeaway: 'Take-away',
    seat: 'Left',
    tableNo: 'Table No.',
    tableSeparate: 'Open Table',
    updateCount: 'Update No. of Guest',
    personCount: 'No. of People',
    waiter: 'Server',
    printQRCode: 'Print QR Code',
    scanQRCode: 'Scan to Order',
    tableCancel: 'Clear Table',
    order: 'Menu',
    pay: 'Pay',
    detail: 'Details',
    eatCount: 'No. of People',
    eatCountUnit: '',
    tableMove: 'Move',
    left: '',
    tableShare: 'Share Table',
    form: 'From',
    moveTo: 'To',
    tableSelect: 'Select Table',
    orderSelect: 'Select Order',

    tableSatus1: 'Available/Paid',
    tableSatus2: 'In Process',
    tableSatus3: 'Partially Paid',
    tableSatus4: 'Partially Sent',
    noSelect: 'Not Selected',

    inputEatCount: 'No. of People',
    errorMessage: 'Over Table Capacity',

    noTable: 'No Table Setting Found',
  },
  line: {
    navs1: 'Queuing',
    navs2: 'Queue List',

    lineup: 'Get Ticket',
    eatCount: 'No. of People',
    contract: 'Contact Number',
    currentNo: 'Now Calling',
    nextNo: 'Next Calling',
    unit1: '',
    waitCount: 'Waiting',
    unit2: ' Group(s)',
    newNo: 'Last Ticket',
    nextTable: 'Next',
    none: 'None',
    unit: ' Person',
    lineCode: 'Queue Code',
    createTime: 'Create Time',

    index: 'No.',
    codeNo: 'Ticket',
    persons: 'People',
    phone: 'Contact Number',

    passNo: 'Passed',

    lineupSuccess: 'Queue Successful',
    inputEatCount: 'No. of People',
    inputContract: 'Contact Number',
  },
  orderNew: {
    orderNewManage: 'Order Verify',
    agreeOrder: 'Agree & Order',
    agreePay: 'Agree & Pay',
    agree: 'Approve',
    refuse: 'Reject',
    agreed: 'Approved',
    refused: 'Rejected',
    detail: 'Detail',
  },
  order: {
    orderManage: 'Orders',
    orderManage2: 'Expired Orders',
    searchContent: 'Order / Contact No.',
    searchContent2: 'Code Scanner Input',
    search: 'Search',

    selectAll: 'Select All',
    payWay: 'Methods',
    payWay1: 'WeChat Pay',
    payWay2: 'Alipay',
    payWay3: 'Mastercard',
    payWay4: 'Visa',
    payWay5: 'Cash',
    payWay6: 'Apple Pay',
    payWay7: 'Google Pay',
    payWay8: 'Octopus',
    payWay9: 'UnionPay',
    payWay10: 'Amex',
    payWay11: 'Stripe',
    payWay12: 'Credit Card',
    payWay13: 'Cheque',
    orderType: 'Type',
    orderType1: 'Dine-in',
    orderType2: 'Take-away',
    orderType3: 'Delivery Platforms',
    orderType4: 'Dine-in', // Main QR Code Order
    payStatus: 'Status',
    payStatus01: 'Combined',
    payStatus0: 'Refunded',
    payStatus1: 'Unpaid',
    payStatus2: 'Paid',
    payStatus3: 'Untipped',
    detail: 'Details',

    index: 'No.',
    shortdate: 'Time',
    codeText: 'Table/Contact No./Name',
    orderTypeText: 'Type',
    userCost: 'Total',
    payway: 'Methods',

    orderDetail: 'Order Details',
    calcWay: 'Payment Methods',
    unit: 'Person',
    orderNo: 'Order No.',

    itemName: 'Food Details',
    count: 'Quantity',
    itemPrice: 'Price',
    takeoutText: 'Take-away',
    remarks: 'Remarks',

    calcWay0: 'Not Selected',
    calcWay1: 'Pay All',
    calcWay2: 'Pay by Share - Even Split',
    calcWay3: 'Pay by Share - Customize Split',
    calcWay4: 'Pay by Order',

    mustSelect: 'Please Select Order First',

    backMenu: 'Back to Menu',
  },
  item: {
    itemManage: 'Inventory',
    sellOutCancel: 'Resume All',
    sellOut: 'Sold Out All',
    all: 'All',
    hot: 'Popular',
    hide: 'Sold Out',
    yu: 'Remain ',
    stockError: 'Insufficient Inventory',
    stockSet: 'Setting',
    stockSetClear: 'Cancel Setting',
    stockSetDesc: 'Please Enter Number of Order Remaining',
    minCostLimited1: 'The minimum charge for this dish is $',
    minCostLimited2: ', please check your selections',
  },
  shop: {
    shopStatus: 'Store',
    inBusiness: 'Open',
    outBusiness: 'Closing',
    printReport: 'Print Report',
    isContinueClosing: 'You have unpaid order(s). Please confirm to continue.',
    isContinueClosing2: 'There is unprocessed booking information, please handle it before closing the store',
    isPrintClosingReport: 'Do you want to print today’s sales report?',
    closingReport: 'Today Report',
    printDetail: 'Print Detail Report',
    printAll: 'Print Summary Report',
    printDish: 'Order Report',
    printCash: 'Cash In/Out Report',

    cash: 'Cash',
    wechat: 'WeChat Pay',
    alipay: 'Alipay',
    card: 'Credit Card',
    cheque: 'Cheque',
    octopus: 'Octopus',
    stripe: 'Stripe',
    tangshi: 'Dine-in',
    takeout: 'Take away',
    platform: 'Delivery Platforms',
    all: 'Total',
    type: 'Categories',

    closeing: 'Closing…',
    waitingCloseing: 'Processing, please wait…',
    continue: 'Continue',
    faildReason: ' failed, reason: ',
    pleaseEdit: ', please adjust the tips',
  },
  qrcode: {
    qrcodeInvalidManage: 'QR Code Setting',
    qrcodeTable: 'Table QR Code',
    qrcodeTangshi: 'Main QR Code (Dine-in)',
    qrcodeLine: 'Queuing QR Code',
    qrcodeTakeaway: 'Main QR Code (Take-away)',
    open: 'Open',
    close: 'Close',
    '1hour': '1 Hour',
    '2hour': '2 Hour',
    '4hour': '4 Hour',
    '8hour': '8 Hour',
    utillClose: 'Utill Store Closing',
  },
  login: {
    toggloFullScreen_false: 'Full Screen',
    toggloFullScreen_true: 'Exit Full Screen',
    inputName: 'Username',
    inputPsd: 'Password',
    login: 'Sign In',

    inputYourName: 'Please enter your name',
    inputYourPsd: 'Please enter your password',
    notBindShop: 'This account is not bound to a store',
    loginWithManagerAccount: 'Please sign in with manager account',

    inBusiness: 'Open Store',
    outBusiness: 'Keep Closed',
    isOpen: 'Store Status',
    selectShop: 'Select Store',

    clearSellout: 'You have sold out dishes',
    clearSelloutNot: 'Do NOT Return',
    clearSelloutOk: 'Return ALL to Available',

    clock: 'Employee Clock in',
    enter: 'Enter',
    enterPos: 'Enter POS',
    finish: 'Comfirm',
    welcome: 'Welcome, ',
    youNeed: 'You need: ',
    workinClock: 'Clock In',
    workoutClock: 'Clock Out',
    restStart: 'Start Break',
    restEnd: 'End Break',
    date: 'Time',
    workin: 'In',
    workout: 'Out',
    resttime: 'Breaks (mins)',
    worktime: 'Hours (hrs)',
    workStatus1: 'Not Work',
    workStatus2: 'Working',
    workStatus3: 'Resting',
    noCameraWarning: 'Unable to detect camera, please check if authorized',
  },
  reader: {
    readerError1: 'Terminal Disconnected',
    readerError2: 'Cannot find the Terminal (Error 101)',
    readerError3: 'Cannot find the Terminal (Error 101)',
    readerError4: 'Cannot find the selected Terminal',
    readerError5: 'Cannot connect to the Terminal',
    readerError6: 'Bad read, please try again',
    readerError7: 'Payment failed, please try again with another card',
    readerWaiting: 'Please finish the payment through credit card terminal...',
  },
  print: {
    batchPrint: 'Separate Print',
    mergePrint: 'Combine Print',
    selectYourPrintWay: 'Please select how would you like to print',
    mergeWarningMessage1: 'The orders you selected will be combined and can NOT be undone',
    mergeWarningMessage2: 'Please confirm to continue',
    printerError: 'Printer Error',
    partOrderIsPaid: 'Part of your order already paid',
    orderIsPaid: 'Your order already paid',
    foodNotSent: 'You have order NOT send to kitchen. Are you sure to continue the payment?',
  },
  scan: {
    scanResult: 'Result',
    rescan: 'Rescan',
    waitingScaning: 'Waiting Scaning',
    resetScaning: 'Please Click the Rescan Button',
    scanFailedScanAgain: 'Scan failed, please scan again',
    scanFailedNotFoundOrder: 'Cannot find the order, please try again',
  },
  member: {
    member: 'Membership',
    memberAccount: 'Member ID',
    vip: 'VIP',
    becomeVip: 'Join VIP',
    payVip: 'VIP Fee',
    search: 'Search',
    searchContent: 'Phone No./Email/Member QR Code',
    notFindMember: 'No customer information found!',
    updateVip: 'Join',
    renewVip: 'Renew',
    calc: 'Pay',
    bindMember: 'Member',
    bindMemberAndCalc: 'Select Member',
    memberId: 'ID',
    memberNickname: 'Name',
    memberLevel: 'Level',
    memberPhone: 'Phone',
    memberEmail: 'Email',
    memberVipEndTime: 'VIP Expire Date',
    memberScore: 'Points',
    memberBalance: 'Balance',
    charge: 'Top-up',
    chargeAmount: 'Top-up Amount',
    giveAmount1: '',
    giveAmount2: ' Reward',
    giveScore1: '',
    giveScore2: ' Pts Reward',
    giveCoupons: 'Coupon Reward',
    bill: 'Bill',
    balanceChangeType1: 'Top-up',
    balanceChangeType2: 'Dine-in',
    balanceChangeType3: 'Take-away',
    balanceChangeType4: 'Delivery Platform',
    balanceChangeType5: 'Top-up Gift',
    balanceChangeType6: 'Restaurant Edit',
    balanceChangeType7: 'Renew VIP',
    balanceChangeType8: 'ITEM Postage',
    balanceChangeType9: 'Refund',
    year: 'Year',
    month: 'Month',
    time: 'Period',
    mustCost: 'Total',
  },
  report: {
    address: 'Address',
    phone: 'Phone',
    date: 'Date',

    payWay: 'DEPT',
    tangshi: 'HERE',
    takeaway: 'TAKE OUT',
    all: 'TOTAL',

    turnover: 'Total',
    turnoverTip: 'with tax',

    serviceFee: 'Service Charge',
    tipsFee: 'Tips',
    consumptionFee: 'Tax',
    packageFee: 'Packing Fee',
    takeoutDiscountFee: 'Take Out Discount',
    discountFee: 'Coupon',
    count: 'Qty',
    amount: 'Amount',

    unPayed: 'Unpaid',
    returnCash: 'Refunded',

    dinners: 'Guest',
    orderNumber: 'Total Transactions',
    deleteOrderNumber: 'Deleted Check',
    deleteOrderItemNumber: 'Deleted Dish',
    tangshiOrderNumber: 'Dine Here',
    takeoutOrderNumber: 'Take Out',
    takeoutPlatNumber: 'Delivery Platform',

    unitPerson: ' People',
    unitCount: ' Dishes',
    unitOrder: ' Checks',

    memberReport: 'Membership Report',
    payWay2: 'Pay By',
    memberFee: 'VIP Fee',
    memberSellFee: 'VIP + Sales',

    total: 'Total',
    netRevenue: 'Net Sales',
    netRevenueTip: 'without tax & service',
    revenue: 'Sales',
    revenueTip: 'with tax',

    cashInAndOut: 'Cash In & Out',
    cashIn: 'Total Cash In',
    cashOut: 'Total Cash Out',
    detailRecords: 'Records',
    reason: 'Reason',
    time: 'Time',

    combo: 'Combo',
    dish: 'Dish',
    comboDel: 'Deleted Combo',
    dishDel: 'Deleted Dish',
  },
  book: {
    bookList: 'Reservation List',
    bookApprove: 'Requests',
    bookManage: 'Reservations',
    timeSetting: 'Time Settings',
    createBook: 'New Reservation',
    today: 'Today',
    tomorrow: 'Tomorrow',
    all: 'All',

    seat: ' Person',
    contract: 'Contact Person',
    bookTime: 'Reservation Time',
    phoneNumber: 'Phone Number',
    remark: 'Remarks',
    createTime: 'Application Time',

    accept: 'Accept',
    refuse: 'Decline',
    arrival: 'Arrived',
    unarrival: 'Not Arrived',
    cancel: 'Cancel',
    queryCancel: 'Request to Cancel',
    acceptCancel: 'Accept',
    refuseCancel: 'Decline',

    approve: 'Pending',
    accepted: 'Waiting',
    refused: 'Declined', // 管理系统 = 预定失败
    arrivaled: 'Arrived',
    canceled: 'Cancelled',
    success: 'Approved',
    fail: 'Declined',

    refuseReason: 'Reason for Decline',
    full: 'Fully Booked',
    pause: 'Stop Reservation',
    otherReason: 'Others',
    inputOtherReason: 'Please enter the reason',

    book: 'Reservation',
    bookShop: 'Branch',
    bookNumber: 'No. of People',
    bookWhole: 'Block Reservation',
    bookTimeIsRequired: 'Please select the reservation time',
  },
  remark: {
    remark: 'Remarks',
    presetRemark: 'Preset Remarks',
    inputRemark: 'Please enter remarks',
  },
}
